const ServiceDetails = () => {
  const services = [
    {
      id: 'it-consulting',
      icon: 'ri-lightbulb-line',
      title: 'IT Consulting',
      description: 'Strategic technology planning and digital transformation guidance',
      features: [
        'Technology roadmap development',
        'Digital transformation strategy',
        'IT infrastructure assessment',
        'Vendor selection and management',
        'Cost optimization analysis',
        'Risk assessment and mitigation',
      ],
      image: 'https://public.readdy.ai/ai/img_res/bf044756bf09f3fc5be101db59399ee7.jpg',
      gradient: 'from-purple-500 to-purple-600',
    },
    {
      id: 'cloud-migration',
      icon: 'ri-cloud-line',
      title: 'Cloud Migration',
      description: 'Seamless transition to cloud platforms with zero downtime',
      features: [
        'Cloud readiness assessment',
        'Multi-cloud and hybrid solutions',
        'Data migration and synchronization',
        'Application modernization',
        'Performance optimization',
        'Post-migration support',
      ],
      image: 'https://readdy.ai/api/search-image?query=cloud%20computing%20infrastructure%20with%20servers%20and%20data%20flowing%20upward%20to%20cloud%20symbol%20modern%20technology%20visualization%20blue%20and%20white%20tones%20representing%20seamless%20cloud%20migration%20and%20digital%20transformation&width=600&height=400&seq=service-cloud-001&orientation=landscape',
      gradient: 'from-blue-500 to-blue-600',
    },
    {
      id: 'business-support-services',
      icon: 'ri-briefcase-line',
      title: 'Business Support Services',
      description: 'Comprehensive administrative and operational support solutions',
      features: [
        'Administrative task management',
        'Process optimization and automation',
        'Project coordination and tracking',
        'Document management systems',
        'Workflow efficiency analysis',
        'Business operations consulting',
      ],
      image: 'https://readdy.ai/api/search-image?query=professional%20business%20support%20team%20working%20on%20administrative%20tasks%20with%20organized%20documents%20digital%20workflow%20automation%20modern%20office%20environment%20teal%20and%20white%20color%20scheme%20representing%20efficient%20business%20operations%20and%20process%20optimization%20services&width=600&height=400&seq=service-business-support-001&orientation=landscape',
      gradient: 'from-teal-500 to-teal-600',
    },
    {
      id: 'advertisement-marketing-services',
      icon: 'ri-megaphone-line',
      title: 'Advertisement & Marketing Services',
      description: 'Strategic marketing campaigns and brand development',
      features: [
        'Brand strategy and positioning',
        'Digital advertising campaigns',
        'Content marketing and SEO',
        'Marketing analytics and reporting',
        'Email marketing automation',
        'Conversion rate optimization',
      ],
      image: 'https://readdy.ai/api/search-image?query=creative%20marketing%20team%20developing%20advertising%20campaigns%20with%20colorful%20charts%20graphs%20and%20digital%20screens%20showing%20brand%20strategy%20modern%20workspace%20orange%20and%20white%20tones%20representing%20digital%20marketing%20and%20advertisement%20services%20professional%20business%20environment&width=600&height=400&seq=service-marketing-001&orientation=landscape',
      gradient: 'from-orange-500 to-orange-600',
    },
    {
      id: 'smm-management-services',
      icon: 'ri-chat-smile-3-line',
      title: 'SMM Management Services',
      description: 'Expert social media strategy and community engagement',
      features: [
        'Social media strategy development',
        'Content creation and scheduling',
        'Community management and engagement',
        'Influencer partnership coordination',
        'Social media analytics and insights',
        'Paid social advertising campaigns',
      ],
      image: 'https://readdy.ai/api/search-image?query=social%20media%20management%20dashboard%20with%20multiple%20platform%20icons%20engagement%20metrics%20and%20content%20calendar%20modern%20digital%20workspace%20pink%20and%20white%20color%20scheme%20representing%20social%20media%20marketing%20community%20management%20and%20online%20presence%20building%20services&width=600&height=400&seq=service-smm-001&orientation=landscape',
      gradient: 'from-pink-500 to-pink-600',
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="space-y-24">
          {services.map((service, index) => (
            <div
              key={index}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                <div className={`w-16 h-16 flex items-center justify-center bg-gradient-to-br ${service.gradient} rounded-2xl mb-6`}>
                  <i className={`${service.icon} text-white text-3xl`}></i>
                </div>
                <h3 className="text-4xl font-bold text-slate-900 mb-4">
                  {service.title}
                </h3>
                <p className="text-lg text-gray-600 mb-8">
                  {service.description}
                </p>
                <div className="space-y-3 mb-8">
                  {service.features.map((feature, idx) => (
                    <div key={idx} className="flex items-start space-x-3">
                      <i className="ri-check-line text-cyan-500 text-xl mt-1 flex-shrink-0"></i>
                      <span className="text-base text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>
                <button
                  onClick={() => window.REACT_APP_NAVIGATE(`/service/${service.id}`)}
                  className="px-8 py-3 bg-gradient-to-r from-amber-500 to-amber-600 text-white font-semibold rounded-lg hover:from-amber-600 hover:to-amber-700 transition-all shadow-lg whitespace-nowrap cursor-pointer"
                >
                  Buy this Service
                </button>
              </div>
              <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                <div className="relative">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-96 object-cover rounded-2xl shadow-2xl"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/20 to-transparent rounded-2xl"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceDetails;